import { render } from "./NewsletterThanksModal.vue?vue&type=template&id=4601bc57&scoped=true"
import script from "./NewsletterThanksModal.vue?vue&type=script&lang=js"
export * from "./NewsletterThanksModal.vue?vue&type=script&lang=js"

import "./NewsletterThanksModal.vue?vue&type=style&index=0&id=4601bc57&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4601bc57"]])

export default __exports__